import React, { useState, useContext, useCallback, createContext, ReactNode } from 'react';
import { Notification } from '../../components/shared/Notification/Notification';
import { NotificationContextType, NotificationState, NotificationType } from '../../types/notification.types';

const NotificationContext = createContext<NotificationContextType | undefined>(undefined);

export const NotificationProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
    const [notification, setNotification] = useState<NotificationState | null>(null);
    const [currentDuration, setCurrentDuration] = useState<number | undefined>(undefined);

    const showNotification = useCallback((message: string, type: NotificationType, duration?: number) => {
        setNotification({ message, type, id: Date.now() });
        setCurrentDuration(duration);
    }, []);

    const hideNotification = useCallback(() => {
        setNotification(null);
        setCurrentDuration(undefined);
    }, []);

    return (
        <NotificationContext.Provider value={{ showNotification }}>
            {children}
            {notification && (
                <Notification
                    key={notification.id}
                    message={notification.message}
                    type={notification.type}
                    duration={currentDuration}
                    onClose={hideNotification}
                />
            )}
        </NotificationContext.Provider>
    );
};

export const useNotification = (): NotificationContextType => {
    const context = useContext(NotificationContext);
    if (context === undefined) {
        throw new Error('useNotification must be used within a NotificationProvider');
    }
    return context;
};